import { Text } from "@fluentui/react-components";
import { useAtomValue, useSetAtom } from "jotai";
import { ROUTES } from "library/routes";
import { EBenefitContentTab } from "library/types";
import { useBenefitPaymentsData } from "pages/Dashboard/hooks/useBenefitPaymentsData";
import { Trans, useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { selectedBenefitCurrencyAtom } from "store/index";
import { benefitContentTabAtom } from "store/UIBenefitsPage";
import styled from "styled-components";

import { BeneficCurrencySelect } from "./components/BeneficCurrencySelect";
import { EmployeeAndDependentTreeMap } from "./components/EmployeeAndDependentTreeMap";
import { TotalInfoAndCategoryChart } from "./components/TotalInfoAndCategoryChart/TotalInfoAndCategoryChart";

export function Dashboard() {
  const { t } = useTranslation();
  const paymentData = useBenefitPaymentsData();
  const selectedCurrency = useAtomValue(selectedBenefitCurrencyAtom);
  const setSelectedContentTab = useSetAtom(benefitContentTabAtom);
  const navigate = useNavigate();

  const payments = paymentData.rawPayments;

  if (!payments || Object.keys(payments).length === 0) {
    return (
      <NoEnrolledBenefitsContainer>
        <Text weight="semibold" block>
          <Trans
            t={t}
            i18nKey={"hbh.noEnrolledBenefits.label"}
            components={[
              <LinkToEligible
                onClick={() => {
                  setSelectedContentTab(EBenefitContentTab.eligible);
                  navigate(ROUTES.BENEFITS);
                }}
              />,
            ]}
          />
        </Text>
      </NoEnrolledBenefitsContainer>
    );
  }

  return (
    <Container>
      <BeneficCurrencySelect />
      {selectedCurrency ? (
        <Content>
          <TotalInfoAndCategoryChart />
          <EmployeeAndDependentTreeMap />
        </Content>
      ) : null}
    </Container>
  );
}

const Container = styled.div`
  width: 100%;
  margin-bottom: 40px;
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  gap: 10px;
`;

const LinkToEligible = styled.span`
  color: ${({ theme }) => theme.palette.green};
  text-decoration: underline;
  cursor: pointer;
`;

const NoEnrolledBenefitsContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  max-width: 600px;
  margin: 20px;
`;
